import CollectUserData from "./collectUserData.service";

const collectUserDataModule = angular
  .module("app.services.collectUserData", [])
  .service("CollectUserData", CollectUserData);

export default collectUserDataModule;



// WEBPACK FOOTER //
// ./src/services/collectUserData/collectUserData.module.js